import { useEffect } from 'react';
export const useWheelScroll = ({ containerRef, selectorRef, getScrollElement })=>{
    useEffect(()=>{
        const container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
        if (container == null) return;
        const handleWheel = (event)=>{
            if (!(event.target instanceof Node)) return;
            const scrollElement = getScrollElement();
            if (scrollElement == null) return;
            if (scrollElement.contains(event.target)) return;
            const tabList = selectorRef.current;
            if (tabList != null && tabList.contains(event.target)) return;
            scrollElement.scrollBy({
                top: event.deltaY
            });
            event.preventDefault();
        };
        container.addEventListener('wheel', handleWheel, {
            passive: false
        });
        return ()=>container.removeEventListener('wheel', handleWheel);
    }, [
        containerRef,
        selectorRef,
        getScrollElement
    ]);
};
